import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Address } from "src/app/ordering-platform/classes/Address";
import { AddressService } from "../addressservice.service";

@Injectable({
    providedIn: 'root'
})
export class AddressHelperService {

  constructor(private addressService: AddressService) {
  }

  searchpostcode(value: string, requireEastingNorthing: boolean = false): Observable<Address[]> {
    return this.addressService.GetAddresses(value, requireEastingNorthing);
  }

  searchTitleInfo(value: string, requireEastingNorthing: boolean = false): Observable<Address[]> {
    return this.addressService.GetAddresses(value, requireEastingNorthing);
  }

  searchUprn(value: string, requireEastingNorthing: boolean = false): Observable<Address[]> {
    return this.addressService.GetAddresses(value, requireEastingNorthing);
  }
}

